import { useEffect, useState } from "react";
import {
  getConnectionEpoch,
  onConnectionEpochChange,
} from "./socketManager";

export function useConnectionEpoch(): number {
  const [epoch, setEpoch] = useState<number>(getConnectionEpoch());

  useEffect(() => {
    const unsub = onConnectionEpochChange((next) => setEpoch(next));
    return unsub;
  }, []);

  return epoch;
}
